import React from "react";
import { TableRow, TableCell, Box } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import AnnulledChip from "./AnnulledChip";

// annulledSource: set when this is the copy of an annulled radicado. The copy
// stays in the expediente and keeps opening; it only says it is void.
const DocumentItem = ({ document, annulledSource, setIsOpenPreview }) => (
  <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
    <TableCell>
      <Box sx={{
        width: 50, height: 60, backgroundColor: 'lightgray', border: 'thin dashed gray', textAlign: 'center'
      }}>
        <img
          alt="preview"
          src={document.thumbUrl ?? '/pdf.png'}
          height={60}
          style={{ backgroundColor: 'white', maxWidth: 50, objectFit: 'contain' }}
          onClick={(evt) => {
            if (!document.thumbUrl) return;
            evt.stopPropagation();
            setIsOpenPreview(document.thumbUrl);
          }}
        />
      </Box>
    </TableCell>
    <TableCell>
      <Box>
        <a href={`/expedients/document/${document.documentId}`} target="_blank" rel="noreferrer">
          {document.documentName}
        </a>
        <Box sx={{ display: 'block', color: '#AAA', fontSize: '.8em' }}>{document.documentType}</Box>
        {annulledSource && <AnnulledChip source={annulledSource} sx={{ mt: 0.5 }} />}
      </Box>
    </TableCell>
    <TableCell>
      {document.folios}
    </TableCell>
    <TableCell>
      <a href={document.documentUrl} target="_blank" rel="noreferrer">
        <OpenInNewIcon size={20} />
      </a>
    </TableCell>
  </TableRow>
);

export default DocumentItem;
